import { render } from "./06_DashobardOrderStatus.vue?vue&type=template&id=32cb78cd"
import script from "./06_DashobardOrderStatus.vue?vue&type=script&lang=js"
export * from "./06_DashobardOrderStatus.vue?vue&type=script&lang=js"

import "./06_DashobardOrderStatus.vue?vue&type=style&index=0&id=32cb78cd&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__